<template>
   <div class="d-flex justify-content-center">
      <div v-if="cellTable">
         <div class="tbl-btn rounded">
            <div class="p-1 hl-sty">
               <b class="p-1">({{cellTable.id}}) {{cellTable.name}}</b>
            </div>
            <div class="clmn-1 table-responsive">
               <!--
               {{cellTable}}
               <hr/>
               {{cellContent}}
               <hr/>
               {{ countDown }}
               -->
               <table class="table table-borderless mb-0">  <!-- table-border(ed/less) -->
                  <tbody>
                     <tr>
                        <td v-if="typeof cellContent[0] === 'undefined'">
                           <div class="card" style="background-color: rgb(225, 225, 225);">
                              <div class="card-header bg-transparent">Lista sin Contenido</div>
                           </div>
                        </td>
                     </tr>
                     <tr v-for="(card, index) in cellContent" :key="index">
                        <td class="p-1">
                           <Cell :cell_id="card" />
                        </td>
                     </tr>
                     <!--
                     -->
                  </tbody>
               </table>
            </div>
            <div>
               <!--
               <button v-if="cellTable.addContent" class="btn btn-sm btn-card " v-on:click="addCard()"><b>+ Tarjeta</b></button>
               <button type="button" class="btn btn-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">
                -->
               <button v-if="cellTable.addContent" type="button" class="btn btn-sm btn-card"  data-bs-toggle="modal" data-bs-target="#tarjeta">
                  <b>+ Tarjeta</b>
               </button>
               <br/>
            </div>
         </div>
      </div>
   </div>
<!-- Modal -->
<MdContent :column_id="column.id"/>
<!--
<div class="modal fade" id="tarjeta" tabindex="-1" aria-labelledby="tarjeta" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Ver Data</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <hr/>
         <hr/>
         parametros:
      </div>
    </div>
  </div>
</div>
     -->
</template>

<script>
import Cell from '../workSpace/components/ContentTableTypeList.vue';
import MdContent from '../workSpace/components/MdContentTableTypeList.vue';   // src\modules\workSpace\components\MdContent.vue
import WspService from "../workSpace/workSpace.service";

export default {
   name: 'CellTable',
   components: {
      Cell,
      MdContent
   },
   props: {
      row: {
         type: Object
      },
      column: {
         type: Object
      },
   },
   data() {
      return {
         cellTable: null,
         cellContent: null,
         netError: false,
         countDown : 5,
      };
   },
   mounted() {
      this.$nextTick(() => {
         console.log("cargando celda ("+this.row.id+","+this.column.id+")");
         this.getCell(this.row.id, this.column.id);
      });
   },
   methods: {
      //
      countDownTimer() {
            //if (!this.netError) {
            if(this.countDown > 5) {
               if(this.countDown > 0) {
                  setTimeout(() => {
                     this.countDown -= 1
                     this.countDownTimer()
                  }, 1000)
               } else {
                  this.getCell(this.row.id, this.column.id);
                  this.countDown = 7;
                     this.countDownTimer();
               }
            }
      },
      //
      getCell:function(row, column) {
         // document.activeElement.blur();
         //this.loading = true;
         //console.log("cargando array modulos");
         this.netError = false;
         //WspService.getColumns(1, 1).then(
         WspService.getCell(row, column).then(
            (response) => {
               //console.log(response.data);
               this.cellContent = response.data.cellContents;   //.wspContents;
               this.cellTable = response.data.wspCell;

            },
            (error) => {
               this.content =  
                  (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
               error.message ||
               error.toString();
               //this.content = "Error de sistema (UserAppModules): " + this.content;
               console.log(error);
               this.netError = true;
               //console.log(error.status);
            }
         );
      },
      addCard() {
         /*
         console.log(index);
         this.listCards = [1, ...this.listCards]
         */
      },
   },
   //
   created() {
      this.countDownTimer()
   }
   //
}
</script>

<style scoped>
.clmn-1 {
   width: 270px;
   max-height: calc(100vh - 215px);
   background-color: lightgrey;
}
.tbl-btn {
   background-color: lightgrey;  
}
.hl-sty {
   width: 270px;
}
</style>